<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    :title="title"
    :visible.sync="dialogFormVisible"
    @closed="closed"
    :modal="false"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
        <el-input
          v-model="editForm.name"
          autocomplete="off"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="手机号/工号"
        :label-width="formLabelWidth"
        prop="mobile"
      >
        <el-input
          v-model="editForm.mobile"
          type="text"
          maxlength="11"
          autocomplete="off"
          placeholder="请输入手机号/工号"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="通知方式"
        :label-width="formLabelWidth"
        prop="noticeType"
      >
        <el-select
          class="search-select"
          v-model="editForm.noticeType"
          placeholder="请选择通知方式"
          @change="handleSelectType"
        >
          <el-option label="邮件" :value="1"></el-option>
          <el-option label="研祥通" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="联系信息"
        :label-width="formLabelWidth"
        prop="contactInfo"
        ref="contactInfo"
      >
        <el-input
          type="text"
          v-model="editForm.contactInfo"
          placeholder="请输入联系信息"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="启用/禁用"
        :label-width="formLabelWidth"
        prop="isFlag"
      >
        <el-select
          class="search-select"
          v-model="editForm.isFlag"
          placeholder="请选择启用/禁用"
        >
          <el-option label="启用" :value="true"></el-option>
          <el-option label="禁用" :value="false"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button style="margin: 0 10px 0" type="primary" @click="submitEdit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { addNoticeApi, editNoticeApi } from '@/api/notice';
export default {
  data() {
    return {
      title: '',
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      // 编辑表单
      editForm: {
        id: null,
        name: '',
        mobile: '',
        noticeType: '',
        contactInfo: '',
        isFlag: null,
      },
      houseId: null,
      personType: null,
      // 表单的验证规则
      editRules: {
        name: [{ required: true, message: '姓名不能为空！', trigger: 'blur' }],
        mobile: [
          { required: true, message: '手机号/工号不能为空！', trigger: 'blur' },
          // {
          //   required: true,
          //   pattern: /^1[3456789]\d{9}$/,
          //   message: '手机号格式不正确',
          //   trigger: 'blur',
          // },
        ],
        noticeType: [
          { required: true, message: '请选择通知方式！', trigger: 'blur' },
        ],
        contactInfo: [
          { required: true, message: '请输入联系信息！', trigger: 'blur' },
        ],
        isFlag: [
          { required: true, message: '请选择启用/禁用！', trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    // console.log('form', this.editForm);
  },
  methods: {
    // 邮件/研祥通 选择下拉框
    handleSelectType(val) {
      // console.log(val);
      if (val == 1) {
        // 邮件
        let newRule = {
          required: true,
          pattern:
            /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
          message: '邮箱格式不正确',
          trigger: 'blur',
        };
        this.editRules.contactInfo.push(newRule);
      } else {
        this.$refs['contactInfo'].resetField('contactInfo');
        if (this.editRules.contactInfo.length > 1)
          this.editRules.contactInfo.pop();
      }
    },
    // 提交按钮
    submitEdit() {
      try {
        this.$refs.editForm.validate((valid) => {
          if (!valid) return;
          if (this.title.indexOf('新增') > -1) {
            this.handleAdd();
          } else {
            this.handleEdit();
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 添加
    async handleAdd() {
      try {
        let res = await addNoticeApi({
          ...this.editForm,
          isFlag: this.editForm.isFlag ? 1 : 0,
          personType: this.personType,
          houseId: this.houseId,
        });
        if (res.code == 200) {
          this.$message.success('新增成功');
          this.dialogFormVisible = false;
          this.resetForm();
          this.$emit('refresh');
        } else {
          this.$message.warning('新增失败');
        }
      } catch (error) {
        this.$message.warning('新增失败');
      }
    },
    // 编辑
    async handleEdit() {
      try {
        let res = await editNoticeApi({
          ...this.editForm,
          isFlag: this.editForm.isFlag ? 1 : 0,
        });
        if (res.code == 200) {
          this.$message.success('编辑成功');
          this.dialogFormVisible = false;
          this.resetForm();
          this.$emit('refresh');
        } else {
          this.$message.warning('编辑失败');
        }
      } catch (error) {
        this.$message.warning('编辑失败');
      }
    },
    // 关闭时的回调
    closed() {
      this.dialogFormVisible = false;
      this.resetForm();
    },

    // 清空表单
    resetForm() {
      this.editForm = {
        id: null,
        name: '',
        mobile: '',
        noticeType: '',
        contactInfo: '',
        isFlag: null,
      };
      this.$refs['editForm'].resetFields();
      // console.log('editForm', this.$refs['editForm'], this.editForm);
    },
  },
};
</script>
